var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"prz-social-authorship"},[_c('div',{staticClass:"prz-social-authorship-name"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),(_vm.verified)?_c('div',{staticClass:"prz-social-authorship-icon"},[_c('i',{staticClass:"prz-diamond"})]):_vm._e(),_c('div',{staticClass:"prz-social-authorship-type",class:{
            'asked': _vm.isQuestion, 
            'comment': _vm.isComment,
            'pending': _vm.isPending
        }},[_vm._v(" "+_vm._s(_vm.typeText)+" ")]),(_vm.date)?_c('div',{staticClass:"prz-social-authorship-date"},[_vm._v(" "+_vm._s(_vm.date)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }